var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import MiniRegoForm from './components/MiniRegoForm';
import './styles/tiof-styles.scss';
// Store references to root elements to prevent duplicate creation
var rootRegistry = new WeakMap();
// Enhanced error boundary with more detailed error reporting
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ errorInfo: errorInfo });
        if (window.tiofDebug) {
            window.tiofDebug.error('React Error Boundary caught error', {
                error: error.toString(),
                componentStack: errorInfo.componentStack
            });
        }
    };
    ErrorBoundary.prototype.render = function () {
        var _a, _b;
        if (this.state.hasError) {
            return (_jsxs("div", { style: { padding: '20px', color: 'red', backgroundColor: '#fff' }, children: [_jsx("h2", { children: "Something went wrong in the Trade In Offer Form." }), _jsx("p", { children: "Please try refreshing the page or contact support if the problem persists." }), _jsxs("pre", { style: { whiteSpace: 'pre-wrap', backgroundColor: '#f5f5f5', padding: '10px' }, children: ["Error: ", ((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error occurred', ((_b = this.state.errorInfo) === null || _b === void 0 ? void 0 : _b.componentStack) && (_jsxs(_Fragment, { children: [_jsx("br", {}), "Component Stack:", this.state.errorInfo.componentStack] }))] })] }));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
// Initialize React with enhanced error handling
function initializeReactApp() {
    // Check for main form container
    var mainFormElement = document.getElementById('vehicle-trade-in-form-root');
    if (mainFormElement && !rootRegistry.has(mainFormElement)) {
        try {
            var root = createRoot(mainFormElement);
            rootRegistry.set(mainFormElement, root);
            root.render(_jsx(ErrorBoundary, { children: _jsx(App, {}) }));
            if (window.tiofDebug) {
                window.tiofDebug.log('Main form initialized successfully');
            }
        }
        catch (error) {
            if (window.tiofDebug) {
                window.tiofDebug.error('Main form initialization failed', error);
            }
        }
    }
    // Initialize mini forms
    var miniFormContainers = document.querySelectorAll('.tiof-mini-form-container, [data-tiof-mini-form]');
    miniFormContainers.forEach(function (container) {
        var _a;
        if (rootRegistry.has(container)) {
            return;
        }
        try {
            var root = createRoot(container);
            rootRegistry.set(container, root);
            var redirectUrl = container.getAttribute('data-redirect-url') || '';
            var buttonText = container.getAttribute('data-button-text') || 'Get Your Offer';
            var title = container.getAttribute('data-title') || '';
            root.render(_jsx(ErrorBoundary, { children: _jsx(MiniRegoForm, { redirectUrl: redirectUrl, buttonText: buttonText, title: title, states: ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.states) || [] }) }));
            if (window.tiofDebug) {
                window.tiofDebug.log('Mini form initialized successfully', {
                    container: container,
                    redirectUrl: redirectUrl,
                    buttonText: buttonText,
                    title: title
                });
            }
        }
        catch (error) {
            if (window.tiofDebug) {
                window.tiofDebug.error('Mini form initialization failed', {
                    error: error,
                    container: container
                });
            }
        }
    });
}
// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReactApp);
}
else {
    initializeReactApp();
}
